import { configureStore } from '@reduxjs/toolkit';


import ApplicationState from "@Reducers";


export const ApplicationStore = configureStore({
    reducer: ApplicationState,
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            thunk: {
                extraArgument: { alive: true }
            }
        }),
});


export type ApplicationStateType = ReturnType<typeof ApplicationState>;


export * from "@Actions-Types";
export * from "@Actions";
export * from "@Reducers";


export default ApplicationStore;
